import { useEffect, useState } from 'react'

const TOTAL_SECONDS = 24 * 60 * 60

const pad = (value: number) => String(value).padStart(2, '0')

/** Et rullende 24-timers nedtælling, der starter forfra ved hvert besøg. */
export function useCountdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS - 14 * 60 - 19)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((current) => (current <= 0 ? TOTAL_SECONDS : current - 1))
    }, 1000)

    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
